<template>

	<div id="logo" :class="{'logo--hide': $route.meta.showModal}" role="img" aria-label="NPO Zappelin logo"></div>

</template>

<script>

export default {

	data() {

		return {

		}
	}
 	
}

</script>

<style scoped>

#logo {
	width: 92px;
	height: 92px;
	/* width: 5%;
	height: 12%; */
	position: fixed;
	background: url('../../assets/images/website/npo-zappelin.png');
	background-repeat: no-repeat;
	background-size: 100%;	
	z-index: 3000;
	top: 20px;
	left: 20px;
	pointer-events: none;
	transition: all .25s ease;
}

.home #logo {
	background: url('../../assets/images/website/zappelin-logo.png');	
	background-repeat: no-repeat;
	background-size: 100%;	
}

.home #logo.logo--hide {
	opacity: 0;
	top: 0px;
}

</style>



// WEBPACK FOOTER //
// Logo.vue?62f552e4